import { isDefined, isNull } from "../../infra3d";
import { Scene as Canvas2dutilScene } from "../utils";
import { USERINPUTTYPE } from "../userinput/internal";
import { MeasureSequence } from "./internal";
/**
 * Stereo Measurment Seqeunce
 * @class MeasurementSequence
 * @author Benjamin Loesch
 */
export class StereoMeasureSequence extends MeasureSequence {
    constructor(scene, successcbf, failedcbf, mx, my) {
        super(scene, successcbf, failedcbf);
        // event variables
        this.mouseupeventnr = null;
        this.mousedowneventnr = null;
        this.mousemoveeventnr = null;
        this.ctrlkeydowneventnr = null;
        this.keyarrowdowneventnmbr = null;
        this.keyarrowupeventnmbr = null;
        this.keyarrowlefteventnmbr = null;
        this.keyarrowrighteventnmbr = null;
        /**
         * @property {number} keytab event number
         * @type {null}
         */
        this.keyc = null;
        this.doubleclkeventnr = null;
        this.featurecollection = null;
        this.pointfeature = null;
        this.pos = null;
        this.sequencestate = 0;
        this.scene2d = null;
        this.pointviewcanvas = null;
        this.pointviewcanvasctx = null;
        /**
         * @property {number} pointviewwidth width of the point view canvas
         * @default 300
         */
        this.pointviewwidth = 300;
        /**
         * @property {number} height of the point view canvas
         * @default 300
         */
        this.pointviewheight = 300;
        this.leftposindicator = null;
        this.rightposindicator = null;
        this.dragelement = null;
        this.stereopos = null;
        this.geoframechanged = -1;
        this.geoframecollectionchanged = -1;
        this.engine = null;
        this.lsmfailed = false;
        this._lsmanimtimer = -1;
        this._t = 0;
        this.measureHandler = null;
        this.geoframecollection = null;
        this.searchwwidth = 200;
        this.searchwheight = 50;
        this.ndisp = -1;
        this.nsearchwwidth = -1;
        this.nsearchwheight = -1;
        this.mapposcenter = null;
        this.lsmworker = null;
        /*
         * Speichert Bild in einen Array -> Dies kann nicht im WebWorker ausgeführt werden...
         *
         * @img Bild das in einen Array umkovertiert werden soll
         * @return gibt den Array zurueck
         */
        this._storeGrayValues = function (img) {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);
            const matrix = [];
            for (let y = 0; y < img.height; ++y) {
                matrix.push([]);
                for (let x = 0; x < img.width; ++x) {
                    const pixelData = canvas.getContext("2d").getImageData(x, y, 1, 1);
                    // Wir nehmen hier den gruenen Kanal.
                    // Falls mit LAB => L gematcht werden will, muss
                    // RGB entsprechend multipliziert werden um RGB->XYZ->LAB zu erhalten
                    matrix[y].push(pixelData.data[1]);
                }
            }
            return matrix;
        };
        this.lsmbutton = null;
        this.engine = this.scene.engine;
        //create the preview canvas
        this.scene2d = new Canvas2dutilScene(0, 0, this.scene.engine.getCanvas().width, this.scene.engine.getCanvas().height, this.scene.engine.getCanvas().parentElement);
        this.pointviewcanvas = document.createElement("canvas");
        this.pointviewcanvas.style.width = this.pointviewwidth + "px";
        this.pointviewcanvas.style.height = this.pointviewheight + "px";
        this.pointviewcanvas.oncontextmenu = function () {
            return false;
        };
        this.pointviewcanvas.width = this.pointviewwidth;
        this.pointviewcanvas.height = this.pointviewheight;
        this.pointviewcanvas.style.position = "absolute";
        this.pointviewcanvas.style.right = "0px";
        this.pointviewcanvas.style.top = "0px";
        this.pointviewcanvas.style.pointerEvents = "none";
        this.scene.engine.getCanvas().parentElement.appendChild(this.pointviewcanvas);
        this.pointviewcanvasctx = this.pointviewcanvas.getContext("2d");
        this.pointviewcanvasctx.fillRect(0, 0, this.pointviewcanvas.width, this.pointviewcanvas.height);
        this.pointviewcanvas.style.boxShadow = "0px 0px 11px 3px rgb(0, 0, 0)";
        this.hidePointView();
        this.startseqeunce();
        //fake event
        const evt = { offsetX: mx, offsetY: my };
        this._onMouseDown(evt);
    }
    /**
     * @method startseqeunce start the measure sequence - subscribe needed events etc.
     */
    startseqeunce() {
        //todo: refactor once key-events are implemented
        this.scene.viewer.getComponent("keyboard").deactivate();
        //subscribe events
        this.mousedowneventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEDOWN, this._onMouseDown, this);
        this.mousemoveeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._onMouseMove, this);
        this.mouseupeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEUP, this._onMouseUp, this);
        this.doubleclkeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.DOUBLECLICK, this._onDblClick, this);
        this.ctrlkeydowneventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ENTER, this._onEnterKey, this);
        this.keyc = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_C, this._onKeyC, this);
        this.geoframechanged = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, this.reset, this);
        this.geoframecollectionchanged = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, this.reset, this);
        this.keyarrowlefteventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ARROW_LEFT, this._arrowleft, this);
        this.keyarrowrighteventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ARROW_RIGHT, this._arrowright, this);
        this.keyarrowupeventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ARROW_UP, this._arrowup, this);
        this.keyarrowdowneventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ARROW_DOWN, this._arrowdown, this);
        this.scene.getCursorStyleHandler().setCursorStyle("crosshair");
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        stereogeoframecollection.imagequadtree.onZoom = (d) => {
            this.updateIndicatorPosition();
        };
        stereogeoframecollection.imagequadtree.onPan = (dx, dy) => {
            this.updateIndicatorPosition();
        };
        stereogeoframecollection.rightimagequadtree.onZoom = (d) => {
            this.updateIndicatorPosition();
        };
        stereogeoframecollection.rightimagequadtree.onPan = (dx, dy) => {
            this.updateIndicatorPosition();
        };
        this.sequencestate = 0;
    }
    /**
     * @method destroy aborts the seqeunce
     */
    destroy() {
        this.abortsequence();
    }
    /**
     *  @method reset resets the sequence to start a new measurement
     */
    reset() {
        //todo: refactor once key-events are implemented
        this.scene.viewer.getComponent("keyboard").activate();
        this.scene.getCursorStyleHandler().setCursorStyle("crosshair");
        this.hidePointView();
        this.setLeftImage();
        this.scene2d.remove(this.leftposindicator);
        this.scene2d.remove(this.lsmbutton);
        this.scene2d.remove(this.rightposindicator);
        this.leftposindicator = null;
        this.lsmbutton = null;
        this.rightposindicator = null;
        this._pixelposrightX = undefined;
        this._pixelposrightY = undefined;
        this._pixelposleftX = undefined;
        this._pixelposleftY = undefined;
        this.sequencestate = 0;
    }
    _finishmeasurement() {
        this.scene.infrascene.traversalState.lockNavigation = false;
        this.setLeftImage();
        if (this.successcbf)
            this.successcbf(this.stereopos);
    }
    /**
     * @public abortsequence aborts the seqeunce, unsubscribes events
     */
    abortsequence() {
        if (this._lsmanimtimer > -1)
            window.clearTimeout(this._lsmanimtimer);
        if (this.lsmworker != null)
            this.lsmworker.terminate();
        //todo: refactor once key-events are implemented
        this.scene.viewer.getComponent("keyboard").activate();
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEDOWN, this.mousedowneventnr);
        this.mousedowneventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this.mousemoveeventnr);
        this.mousemoveeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEUP, this.mouseupeventnr);
        this.mouseupeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ENTER, this.ctrlkeydowneventnr);
        this.ctrlkeydowneventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, this.geoframechanged);
        this.geoframechanged = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, this.geoframecollectionchanged);
        this.geoframecollectionchanged = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ARROW_LEFT, this.keyarrowlefteventnmbr);
        this._arrowleft = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ARROW_RIGHT, this.keyarrowrighteventnmbr);
        this._arrowright = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ARROW_UP, this.keyarrowupeventnmbr);
        this._arrowup = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ARROW_DOWN, this.keyarrowdowneventnmbr);
        this._arrowdown = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_C, this.keyc);
        this.keyc = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_C, this.doubleclkeventnr);
        this.doubleclkeventnr = null;
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        stereogeoframecollection.imagequadtree.onZoom = null;
        stereogeoframecollection.imagequadtree.onPan = null;
        stereogeoframecollection.rightimagequadtree.onZoom = null;
        stereogeoframecollection.rightimagequadtree.onPan = null;
        this.scene.engine.getCanvas().parentElement.removeChild(this.pointviewcanvas);
        this.scene2d.destroy();
        this.successcbf = null;
        this.failedcbf = null;
        this.reset();
    }
    _startLSM() {
        if (this._lsmanimtimer > -1)
            return;
        if (this.rightposindicator) {
            this.scene.infrascene.hideAllFeatures();
            this._t = 0;
            this.rightposindicator.changeColor("white");
            this.leftposindicator.changeColor("white");
            this.scene2d.render();
            /* this.lsmworker = new LSMWorker(); */
            this.lsmworker = new Worker(new URL("./lsm.worker.js", import.meta.url));
            this.lsmworker.onmessage = (e) => {
                this._lsmworkercb(e);
            };
            //callback for animation update
            const cb = () => {
                this.rightposindicator.scale = 30 - (Math.cos(this._t / 250) / 2 + 1) * 10;
                this.leftposindicator.scale = 30 - (Math.cos(this._t / 250) / 2 + 1) * 10;
                this.scene2d.render();
                this.scene.infrascene.render();
                this._t += 50;
            };
            this._lsmanimtimer = window.setInterval(() => {
                cb();
            }, 10);
            const wwidth = this.scene.lsmprops["templateWidth"]; //in pixel
            const wheight = this.scene.lsmprops["templateHeight"]; //in pixel
            this.searchwwidth = this.scene.lsmprops["searchWindowWidth"];
            this.searchwheight = this.scene.lsmprops["templateHeight"];
            this.geoframecollection = this.scene.getCurrentGeoFrameCollection();
            this.measureHandler = this.scene.getMeasureHandler();
            const minfo = this.scene.getCurrentGeoframe().getMeasureInfo();
            this.quadtreesize = minfo.imagemeta.tilesize * Math.pow(2, minfo.imagemeta.maxzoom);
            const nwwidth = wwidth / this.quadtreesize; //normalized window width
            const nwheight = wheight / this.quadtreesize;
            this.nsearchwwidth = this.searchwwidth / this.quadtreesize;
            this.nsearchwheight = this.searchwheight / this.quadtreesize;
            this.mapposcenter = this.scene
                .getMeasureHandler()
                .mouseToMap(this.leftposindicator.position.x, this.leftposindicator.position.y)[0].coords; //this.leftposindicator.position.x-wwidth/2)/
            //get disparity in pixel
            const mp = this.scene
                .getMeasureHandler()
                .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), this.leftposindicator.position.x, this.leftposindicator.position.y);
            const measureinfo = mp.geoframe.getMeasureInfo();
            const dispinpix = mp.disparity * (measureinfo.depthmapmeta.pixsize / measureinfo.imagemeta.pixsize);
            this.ndisp = dispinpix / this.quadtreesize;
            this.scene
                .getCurrentGeoFrameCollection()
                .getCurrentGeoFrame()
                .downloadCurrentFrame(this.mapposcenter.x - nwwidth / 2, this.mapposcenter.y - nwheight / 2, this.mapposcenter.x + nwwidth / 2, this.mapposcenter.y + nwheight / 2, this.scene.getCurrentGeoframe().getMeasureInfo().imagemeta.maxzoom, (leftdataurl) => {
                //now get the right window from right image
                const rightimagereadycbf = () => {
                    this.geoframecollection.rightimagequadtree.visibleTilesReady = null;
                    this.scene
                        .getCurrentGeoFrameCollection()
                        .getCurrentGeoFrame()
                        .downloadCurrentFrame(this.mapposcenter.x - this.ndisp - this.nsearchwwidth / 2, this.mapposcenter.y - this.nsearchwheight / 2, this.mapposcenter.x - this.ndisp + this.nsearchwwidth / 2, this.mapposcenter.y + this.nsearchwheight / 2, this.scene.getCurrentGeoframe().getMeasureInfo().imagemeta.maxzoom, (rightdataurl) => {
                        // Bilder in den Canvas zeichnen (davon wird dann matrize generiert)
                        const leftimg = new Image();
                        const rightimg = new Image();
                        leftimg.width = this.scene.lsmprops["templateWidth"];
                        leftimg.height = this.scene.lsmprops["templateHeight"];
                        rightimg.width = this.searchwwidth;
                        rightimg.height = this.searchwheight;
                        let mattempl = [];
                        //set callback for base64 decoding... first left, then right
                        leftimg.onload = () => {
                            mattempl = this._storeGrayValues(leftimg);
                            rightimg.src = rightdataurl;
                        };
                        rightimg.onload = () => {
                            const matsearch = this._storeGrayValues(rightimg);
                            //then start worker:
                            this.lsmworker.postMessage({
                                topic: "run",
                                template: mattempl,
                                searchwindow: matsearch,
                                searchwindowposquality: mp.quality / 255,
                                NCC_Threshold: this.scene.lsmprops["NCC_Threshold"],
                                adjustRadiometry: this.scene.lsmprops["adjustRadiometry"],
                            });
                        };
                        //go:
                        leftimg.src = leftdataurl;
                    });
                };
                this.setRightImage();
                //Todo: refactor this
                if (this.geoframecollection.rightimagequadtree._allTilesReady) {
                    rightimagereadycbf();
                }
                else {
                    this.geoframecollection.rightimagequadtree.visibleTilesReady = rightimagereadycbf;
                }
            });
        }
    }
    _lsmworkercb(result) {
        this.scene.infrascene.showAllFeatures();
        if (result.data != null) {
            const p = this.measureHandler.mapToMouse(this.mapposcenter.x - this.ndisp - this.nsearchwwidth / 2 + result.data[0] / this.quadtreesize, this.mapposcenter.y - this.nsearchwheight / 2 + result.data[1] / this.quadtreesize);
            this._lsmsuccess(p.x, p.y);
        }
        else {
            this._lsmfailed();
        }
    }
    _stopLSM() {
        window.clearInterval(this._lsmanimtimer);
        this._lsmanimtimer = -1;
        this.rightposindicator.scale = 30;
        this.leftposindicator.scale = 30;
        this.scene2d.render();
        this.scene.infrascene.render();
    }
    _lsmsuccess(x, y) {
        this._stopLSM();
        this.rightposindicator.scale = 30;
        this.leftposindicator.scale = 30;
        this.rightposindicator.position.x = x;
        this.rightposindicator.position.y = y;
        const map = this.geoframecollection.imagequadtree.mouseToMap(this.rightposindicator.position.x, this.rightposindicator.position.y);
        const imagemeta = this.geoframecollection.measureinfo.imagemeta;
        this._pixelposrightX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        this._pixelposrightY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        this.rightposindicator.changeColor("lightgreen");
        this.leftposindicator.changeColor("lightgreen");
        this.scene2d.render();
        this.scene.infrascene.render();
        this.updateIndicatorPosition();
    }
    _lsmfailed() {
        this._stopLSM();
        this.rightposindicator.changeColor("red");
        this.leftposindicator.changeColor("red");
        this.lsmfailed = true;
        this.scene2d.render();
        this.updateIndicatorPosition();
    }
    _arrowleft(evt) {
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        const imagemeta = stereogeoframecollection.getCurrentGeoFrame().getMeasureInfo().imagemeta;
        if (stereogeoframecollection.activeimage == "right") {
            this.rightposindicator.position.x -= 1;
            const map = stereogeoframecollection.imagequadtree.mouseToMap(this.rightposindicator.position.x, this.rightposindicator.position.y);
            this._pixelposrightX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            this._pixelposrightY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        }
        if (stereogeoframecollection.activeimage == "left") {
            this.leftposindicator.position.x -= 1;
            const map = stereogeoframecollection.imagequadtree.mouseToMap(this.leftposindicator.position.x, this.leftposindicator.position.y);
            this._pixelposleftX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            this._pixelposleftY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        }
        this.leftposindicator.changeColor("white");
        this.rightposindicator.changeColor("white");
        this.lsmfailed = false;
        this.scene2d.render();
    }
    _arrowright(evt) {
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        const imagemeta = stereogeoframecollection.getCurrentGeoFrame().getMeasureInfo().imagemeta;
        if (stereogeoframecollection.activeimage == "right") {
            this.rightposindicator.position.x += 1;
            const map = stereogeoframecollection.imagequadtree.mouseToMap(this.rightposindicator.position.x, this.rightposindicator.position.y);
            this._pixelposrightX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            this._pixelposrightY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        }
        if (stereogeoframecollection.activeimage == "left") {
            this.leftposindicator.position.x += 1;
            const map = stereogeoframecollection.imagequadtree.mouseToMap(this.leftposindicator.position.x, this.leftposindicator.position.y);
            this._pixelposleftX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            this._pixelposleftY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        }
        this.leftposindicator.changeColor("white");
        this.rightposindicator.changeColor("white");
        this.lsmfailed = false;
        this.scene2d.render();
    }
    _arrowup(evt) {
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        const imagemeta = stereogeoframecollection.getCurrentGeoFrame().getMeasureInfo().imagemeta;
        if (stereogeoframecollection.activeimage == "right" && evt.ctrlKey) {
            this.rightposindicator.position.y -= 1;
            const map = stereogeoframecollection.imagequadtree.mouseToMap(this.rightposindicator.position.x, this.rightposindicator.position.y);
            this._pixelposrightX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            this._pixelposrightY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        }
        if (stereogeoframecollection.activeimage == "left" && evt.ctrlKey) {
            this.leftposindicator.position.y -= 1;
            const map = stereogeoframecollection.imagequadtree.mouseToMap(this.leftposindicator.position.x, this.leftposindicator.position.y);
            this._pixelposleftX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            this._pixelposleftY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        }
        this.leftposindicator.changeColor("white");
        this.rightposindicator.changeColor("white");
        this.lsmfailed = false;
        this.scene2d.render();
    }
    _arrowdown(evt) {
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        const imagemeta = stereogeoframecollection.getCurrentGeoFrame().getMeasureInfo().imagemeta;
        if (stereogeoframecollection.activeimage == "right" && evt.ctrlKey) {
            this.rightposindicator.position.y += 0.5;
            const map = stereogeoframecollection.imagequadtree.mouseToMap(this.rightposindicator.position.x, this.rightposindicator.position.y);
            this._pixelposrightX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            this._pixelposrightY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        }
        if (stereogeoframecollection.activeimage == "left" && evt.ctrlKey) {
            this.leftposindicator.position.y += 0.5;
            const map = stereogeoframecollection.imagequadtree.mouseToMap(this.leftposindicator.position.x, this.leftposindicator.position.y);
            this._pixelposleftX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            this._pixelposleftY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
        }
        this.leftposindicator.changeColor("white");
        this.rightposindicator.changeColor("white");
        this.lsmfailed = false;
        this.scene2d.render();
    }
    /**
     * Change left / right image when enter is pressed
     * @method _onEnterKey
     * @private
     */
    _onEnterKey() {
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        if (stereogeoframecollection.activeimage == "left") {
            this.setRightImage();
        }
        else {
            this.setLeftImage();
        }
    }
    /**
     * Change left / right image when enter is pressed
     * @method _onEnterKey
     * @private
     */
    _onKeyC() {
        if (this.rightposindicator) {
            this.rightposindicator.changeStyle();
            this.scene2d.render();
        }
        if (this.leftposindicator) {
            this.leftposindicator.changeStyle();
            this.scene2d.render();
        }
    }
    /**
     * internal function mousemove
     * @method _onMouseDown
     * @param evt
     * @private
     */
    _onMouseDown(evt) {
        if (evt.button >= 1)
            return;
        let stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        const imagemeta = stereogeoframecollection.getCurrentGeoFrame().getMeasureInfo().imagemeta;
        //first mouse down
        switch (this.sequencestate) {
            case 0: {
                //first mouse down
                const map = stereogeoframecollection.imagequadtree.mouseToMap(evt.offsetX, evt.offsetY);
                this._pixelposleftX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
                this._pixelposleftY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
                this.sequencestate += 1;
                let disp = 3;
                this.pos = (this.scene
                    .getMeasureHandler()
                    .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), evt.offsetX, evt.offsetY, 10000));
                stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
                const measureinfo = stereogeoframecollection.getCurrentGeoFrame().getMeasureInfo();
                if (this.pos.disparity > 0) {
                    disp = this.pos.disparity * (measureinfo.depthmapmeta.pixsize / measureinfo.imagemeta.pixsize);
                    this._pixelposrightX = this._pixelposleftX - disp;
                    this._pixelposrightY = this._pixelposleftY;
                    this.rightposindicator = this.scene2d.createCrosshair(10, 10, 30);
                }
                else {
                    this._pixelposrightX = this._pixelposleftX - 300;
                    this._pixelposrightY = this._pixelposleftY;
                    this.rightposindicator = this.scene2d.createCrosshair(evt.offsetX - 3, evt.offsetY, 30);
                }
                this.rightposindicator.hide();
                this.leftposindicator = this.scene2d.createCrosshair(evt.offsetX, evt.offsetY, 30);
                this.lsmbutton = this.scene2d.createLsmButton(evt.offsetX, evt.offsetY, 30);
                if (!this.scene.lsmenabled) {
                    this.lsmbutton.hide();
                    this.setRightImage();
                }
                this.lsmbutton.position = this.leftposindicator.position;
                this.updateIndicatorPosition();
                this.scene.getCursorStyleHandler().setCursorStyle("default");
                this.scene2d.render();
                break;
            }
            case 1:
                //align the two points
                this.dragelement = this.scene2d.pick(evt.offsetX, evt.offsetY);
                this.lastdragpos = [evt.offsetX, evt.offsetY];
                if (!isNull(this.dragelement)) {
                    if (this.dragelement == this.lsmbutton) {
                        this._startLSM();
                    }
                    else {
                        this.scene.infrascene.traversalState.lockNavigation = true;
                        this.scene.infrascene.render();
                        this.leftposindicator.changeColor("white");
                        this.rightposindicator.changeColor("white");
                        this.lsmfailed = false;
                    }
                }
                break;
            case 2:
                this.reset();
                this.sequencestate = 0;
                break;
        }
        this.scene2d.render();
    }
    _onDblClick() {
        if (this.sequencestate == 1) {
            if (this.lsmfailed) {
                alert("Automatic point detection failed, please adjust point measurements manually!");
            }
            else {
                this.stereopos = this.scene
                    .getMeasureHandler()
                    .createStereoMeasurePoint(this.scene.getCurrentGeoframe(), this._pixelposleftX, this._pixelposleftY, this._pixelposrightX, this._pixelposrightY, 10000);
                this.sequencestate = 2;
                this._finishmeasurement();
            }
        }
    }
    /**
     * set right image and change indicator positions
     * @method setRightImage
     * @private
     */
    setRightImage() {
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        if (stereogeoframecollection.activeimage == "right")
            return;
        if (!isNull(this.leftposindicator)) {
            this.showPointView(this.leftposindicator.position.x - this.pointviewwidth / 2, this.leftposindicator.position.y - this.pointviewheight / 2, this.pointviewwidth, this.pointviewheight, "L");
            this.leftposindicator.hide();
            this.lsmbutton.hide();
        }
        stereogeoframecollection.showRightImage();
        if (!isNull(this.rightposindicator)) {
            this.rightposindicator.show();
            const d = this.leftposindicator.position.x - this.rightposindicator.position.x;
            this.scene.infrascene.traversalState.cameras["quadtreeCamera"].behaviors[0]._panX += d; //uuuhuu ugly and illegal!!!! -> but it works!
            this.scene.infrascene.render();
            this.updateIndicatorPosition();
        }
        this.scene2d.render();
    }
    /**
     * set left image and change indicator positions
     * @method setLeftImage
     * @private
     */
    setLeftImage() {
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        if (stereogeoframecollection.activeimage == "left")
            return;
        if (!isNull(this.leftposindicator)) {
            this.showPointView(this.rightposindicator.position.x - this.pointviewwidth / 2, this.rightposindicator.position.y - this.pointviewheight / 2, this.pointviewwidth, this.pointviewheight, "R");
            this.rightposindicator.hide();
        }
        stereogeoframecollection.showLeftImage();
        if (!isNull(this.leftposindicator)) {
            this.leftposindicator.show();
            if (this.scene.lsmenabled)
                this.lsmbutton.show();
            const d = this.leftposindicator.position.x - this.rightposindicator.position.x;
            this.scene.infrascene.traversalState.cameras["quadtreeCamera"].behaviors[0]._panX -= d; //uuuhuu ugly and illegal!!!! -> but it works!
            this.updateIndicatorPosition();
        }
        this.scene2d.render();
    }
    /**
     * handle mouse move
     * @param evt
     * @private
     */
    _onMouseMove(evt) {
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        const imagemeta = stereogeoframecollection.getCurrentGeoFrame().getMeasureInfo().imagemeta;
        if (!isNull(this.dragelement)) {
            //dragging is on
            if (stereogeoframecollection.activeimage == "right" && this.rightposindicator == this.dragelement) {
                this.rightposindicator.position.x += evt.offsetX - this.lastdragpos[0];
                if (evt.ctrlKey) {
                    this.rightposindicator.position.y += evt.offsetY - this.lastdragpos[1];
                }
                const map = stereogeoframecollection.imagequadtree.mouseToMap(this.rightposindicator.position.x, this.rightposindicator.position.y);
                this._pixelposrightX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
                this._pixelposrightY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            }
            if (this.leftposindicator == this.dragelement && stereogeoframecollection.activeimage == "left") {
                this.leftposindicator.position.x += evt.offsetX - this.lastdragpos[0];
                if (evt.ctrlKey) {
                    this.leftposindicator.position.y += evt.offsetY - this.lastdragpos[1];
                }
                const map = stereogeoframecollection.imagequadtree.mouseToMap(this.leftposindicator.position.x, this.leftposindicator.position.y);
                this._pixelposleftX = map[0] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
                this._pixelposleftY = map[1] * imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom);
            }
            this.lastdragpos = [evt.offsetX, evt.offsetY];
            this.scene2d.render();
            evt.stopPropagation();
            return;
        }
        else {
            this.updateIndicatorPosition();
        }
        this.scene2d.render();
    }
    /**
     * updates the left and right point according to pan or zoome imagequadtree
     * @private
     */
    updateIndicatorPosition() {
        const stereogeoframecollection = this.scene.getCurrentGeoFrameCollection();
        const imagemeta = stereogeoframecollection.getCurrentGeoFrame().getMeasureInfo().imagemeta;
        if (isDefined(this._pixelposrightX) && isDefined(this._pixelposrightY)) {
            const mapx = this._pixelposrightX / (imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom));
            const mapy = this._pixelposrightY / (imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom));
            const mouse = stereogeoframecollection.imagequadtree.mapToMouse(mapx, mapy);
            this.rightposindicator.position.x = mouse[0];
            this.rightposindicator.position.y = mouse[1];
        }
        if (isDefined(this._pixelposleftX) && isDefined(this._pixelposleftY)) {
            const mapx = this._pixelposleftX / (imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom));
            const mapy = this._pixelposleftY / (imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom));
            const mouse = stereogeoframecollection.imagequadtree.mapToMouse(mapx, mapy);
            this.leftposindicator.position.x = mouse[0];
            this.leftposindicator.position.y = mouse[1];
        }
        this.scene2d.render();
    }
    _onMouseUp(evt) {
        this.dragelement = null;
        this.scene.infrascene.traversalState.lockNavigation = false;
        this.scene.infrascene.render();
        this.updateIndicatorPosition();
    }
    /**
     * Hides the point preview window
     * @private
     */
    hidePointView() {
        this.pointviewcanvas.style.visibility = "hidden";
    }
    /**
     * shows the point preview window with a screenshot from actual view
     * @param ulx
     * @param uly
     * @param w
     * @param h
     * @param label
     */
    showPointView(ulx, uly, w, h, label) {
        this.scene.infrascene.render();
        const arr = this.engine.getImageBuffer(ulx, uly, w, h);
        const image = this.pointviewcanvasctx.createImageData(w, h);
        for (let i = 0; i < arr.length; i++) {
            image.data[i] = arr[i];
        }
        this.pointviewcanvasctx.putImageData(image, 0, 0);
        this.pointviewcanvasctx.lineWidth = 2;
        const ctx = this.pointviewcanvasctx;
        ctx.lineWidth = 1;
        ctx.strokeStyle = "rgba(0,0,0,0.3)";
        ctx.beginPath();
        ctx.moveTo(w / 2, h / 4);
        ctx.lineTo(w / 2, (3 * h) / 4);
        ctx.moveTo(w / 4, h / 2);
        ctx.lineTo((3 * w) / 4, h / 2);
        ctx.stroke();
        ctx.shadowColor = "black";
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.shadowBlur = 1;
        ctx.lineWidth = 1;
        ctx.font = "34px Verdana";
        ctx.fillStyle = "white";
        ctx.fillText(label, 25, 35);
        ctx.strokeStyle = "black";
        ctx.strokeText(label, 25, 35);
        this.pointviewcanvas.style.visibility = "visible";
    }
}
//# sourceMappingURL=stereomeasureseqeunce.js.map